import React from 'react';
import { Spinner } from '@/components/ui/spinner';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface PropagateChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  existingCount: number;
  templateName: string;
  onConfirm: () => void;
  onSkip: () => void;
  isPropagating: boolean;
}

export const PropagateChangesDialog: React.FC<PropagateChangesDialogProps> = ({
  open,
  onOpenChange,
  existingCount,
  templateName,
  onConfirm,
  onSkip,
  isPropagating,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Wijziging toepassen op bestaande schema&apos;s?
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              <p>
                Er zijn <strong>{existingCount}</strong> bestaande
                onderhoudsschema&apos;s gevonden voor &quot;{templateName}&quot;.
              </p>
              <p>
                Wil je deze wijziging ook doorvoeren op alle bestaande schema&apos;s,
                of alleen voor nieuwe voorzieningen?
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={onSkip}
            disabled={isPropagating}
          >
            Alleen voor nieuwe
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isPropagating}
            className="bg-brick-primary hover:bg-brick-primary/90 text-white"
          >
            {isPropagating && <Spinner className="size-4" />}
            Toepassen op alle ({existingCount})
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
